import classNames from 'classnames';
import React from 'react';
import { IconType } from 'components/Icon/constants';
import { Title } from 'components/Toolbar/constants';
import Control from 'components/Toolbar/Controls/Control';
import { ControlState } from 'components/Toolbar/Controls/Control/constants';
import { useControlWithDropdown } from 'components/Toolbar/hooks';
import Dropdown from 'components/Toolbar/Shared/Dropdown';
import { AccessibilityRole } from 'const';
import { intlGet } from 'utils/intlGet';
import styles from './styles.module.scss';

export type AccessibilityOption = {
  value: AccessibilityRole;
  text: string;
};

type Props = {
  accessibilityOptions: AccessibilityOption[];
  currentAccessibilityRole: AccessibilityRole;
  changeAccessibilityRole(value: AccessibilityRole): void;
  dataTestId: string;
};

const AccessibilityRoleControl: React.FunctionComponent<Props> = (props) => {
  const { dataTestId, changeAccessibilityRole, currentAccessibilityRole, accessibilityOptions } = props;
  const controlState = ControlState;
  const { control, isOpen, state, toggleDropdown } = useControlWithDropdown({ controlState });

  const changeAccessibilityRoleHandler = (value: AccessibilityRole): void => {
    changeAccessibilityRole(value);
  };

  return (
    <Control
      controlState={controlState}
      onToggle={toggleDropdown}
      ref={control}
      size="sm-md"
      state={state}
      title={Title.ACCESSIBILITY}
      type={IconType.ACCESSIBILITY}
      dataTestId={`${dataTestId}-control`}
    >
      {isOpen && <Dropdown className={styles.accessibilityRoleDropdown} dataTestId={`${dataTestId}-dropdown`} >
        <div className={styles.title}>{intlGet('AccessibilityRole', 'Title')}</div>
        <div className={styles.screenReader}>{intlGet('AccessibilityRole', 'ScreenReader')}</div>

        {accessibilityOptions.map(
          ({ value, text }, index) => (
            <button className={classNames(styles.item, 'reset-button', [currentAccessibilityRole === value && styles.active])}
              key={value} onClick={(): void => changeAccessibilityRoleHandler(value)}
              data-testid={`${dataTestId}-item${index}`}>
              {text}
            </button>
          ),
        )}
      </Dropdown>
      }
    </Control>
  );
};

export default AccessibilityRoleControl;
